import React from 'react';
import {
  CreateButton,
  ExportButton,
  RefreshButton,
  TopToolbar,
} from 'react-admin';
import { ImportButton } from "react-admin-import-csv";
import DELIMETERS from '../../constants/delimeters';

const CustomActions = ({
  bulkActions,
  basePath,
  exporter,
  filters,
  resource,
  filterValues,
  total,
  hasCreate,
  disableExport,
  showImportButton = false
}) => {
  const exportSort = {
    field: 'createdAt',
    order: 'DESC',
  };

  return (
    <TopToolbar>
 
      {filters && React.cloneElement(filters, { context: 'button'})}
      {hasCreate && <CreateButton basePath={basePath} />}
      <ExportButton
        disabled={total === 0 || disableExport}
        resource={resource}
        sort={exportSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={DELIMETERS.MAX_EXPORT_RESULTS}
      />
      {showImportButton && <ImportButton resource={resource} basePath={basePath} />}
      <RefreshButton />
      {bulkActions && React.cloneElement(bulkActions)}
    </TopToolbar>
  );
};

export default CustomActions;
